const Slovenian = {
    _language: 'slovenia',
    _language_short: 'sl',
    agentWelkomMessage: 'Dobrodošli. Postavite svoje vprašanje tukaj.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Ni se bilo mogoče povezati. Lahko {retry}',
    couldNotConnectInner: 'poskusite znova povezavo',
    couldNotConnectWithRetry: 'Ni se bilo mogoče povezati. Poskušali bomo znova ali pa lahko {retry}.',
    couldNotConnectWithRetryInner: 'poskusite zdaj',
    headerText: 'Kako vam lahko pomagamo?',
    imageClickToReload: 'Kliknite za ponovno nalaganje slike.',
    imageClickToView: 'Kliknite za ogled slike velikosti {size}.',
    imagePreviewNotAvailable: 'Predogled ni na voljo.',
    inputPlaceholder: 'Vnesite besedilo in pritisnite <enter> za pošiljanje.',
    inputPlaceholderBlocked: 'Izpolnite obrazec zgoraj...',
    introAppText: 'Pošljite svoje sporočilo spodaj ali prek svojega najljubšega kanala.',
    introductionText: 'Postavite svoje vprašanje tukaj.',
    actionPaymentCompleted: 'Plačilo prejeto.',
    actionPaymentError: 'Pri obdelavi plačila je prišlo do napake. <br> Poskusite znova ali uporabite drugo kartico.',
    actionPostbackError: 'Pri obdelavi vaše zahteve je prišlo do napake. Poskusite znova.',
    clickToRetry: 'Sporočilo ni bilo dostavljeno. Poskusite znova.',
    clickToRetryForm: 'Obrazec ni bil poslan. Kliknite kjerkoli na obrazcu za ponovno pošiljanje.',
    connectNotificationText: 'Počakajte na odgovor ali izberite aplikacijo, v kateri želite nadaljevati.',
    connectNotificationSingleText: 'Počakajte na odgovor ali izberite aplikacijo, v kateri želite nadaljevati.',
    connectNotificationSingleButtonText: 'Vklopite obvestila za <name>',
    connectNotificationOthersText: 'drugi',
    emailChangeAddress: 'Spremeni moj e-naslov',
    emailDescription: 'Če želite prejeti obvestilo po e-pošti, ko prejmete odgovor, vnesite svoj e-poštni naslov.',
    emailFieldLabel: 'Vaš e-naslov',
    emailFieldPlaceholder: 'Vaš e-poštni naslov',
    emailFormButton: 'Nadaljuj',
    fetchHistory: 'Naloži več',
    fetchingHistory: 'Pridobivanje zgodovine...',
    frontendEmailChannelDescription: 'Pošljite nam e-pošto in odgovorili vam bomo čim prej.',
    invalidFileError: 'Podprte so samo slike. Izberite datoteko s podprto končnico (jpg, jpeg, png, gif ali bmp).',
    lineChannelDescription: 'Skenirajte QR kodo in se pogovarjajte z nami prek LINE.',
    locationNotSupported: 'Vaš brskalnik ne podpira storitev lokacije ali pa so onemogočene. Vnesite svojo lokacijo ročno.',
    locationSecurityRestriction: 'Ta spletna stran ne more dostopati do vaše lokacije. Vnesite jo ročno.',
    locationSendingFailed: 'Lokacije ni bilo mogoče poslati',
    locationServicesDenied: 'Ta spletna stran ne more dostopati do vaše lokacije. Dovolite dostop v nastavitvah ali jo vnesite ročno.',
    messageError: 'Pri pošiljanju vašega sporočila je prišlo do napake. Poskusite znova.',
    messageIndicatorTitlePlural: '({count}) Nova sporočila',
    messageIndicatorTitleSingular: '({count}) Novo sporočilo',
    messageRelativeTimeDay: 'Pred {value} d',
    messageRelativeTimeHour: 'Pred {value} h',
    messageRelativeTimeJustNow: 'Pravkar',
    messageRelativeTimeMinute: 'Pred {value} min',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Pošiljanje...',
    messageDelivered: 'Dostavljeno',
    messengerChannelDescription: 'Povežite svoj Facebook račun za nadaljevanje prek Facebook Messengerja.',
    whatsappChannelDescriptionDesktop: 'Začnite ali nadaljujte pogovor prek WhatsAppa. Kliknite na spodnjo povezavo.',
    whatsappChannelDescriptionMobile: 'Začnite ali nadaljujte pogovor prek WhatsAppa. Kliknite na spodnjo povezavo.',
    whatsappLinkingError: 'Pri povezovanju je prišlo do napake. Poskusite znova.',
    notificationSettingsChannelsDescription: 'Pogovarjate se lahko tudi prek svoje najljubše aplikacije ali storitve.',
    notificationSettingsChannelsTitle: 'Druge aplikacije',
    notificationSettingsConnected: 'Povezano',
    notificationSettingsConnectedAs: 'Povezano kot {username}',
    prechatCaptureGreetingText: 'Pozdravljeni 👋\nZa začetek bi vas radi malo bolje spoznali:',
    prechatCaptureNameLabel: 'Vaše ime',
    prechatCaptureNamePlaceholder: 'Vnesite svoje ime...',
    prechatCaptureEmailLabel: 'E-pošta',
    prechatCaptureEmailPlaceholder: 'ime@podjetje.com',
    prechatCaptureConfirmationText: 'Hvala! Kako vam lahko pomagamo?',
    prechatCaptureMailgunLinkingConfirmation: 'Obvestilo boste prejeli tukaj in na e-poštni naslov {email}.',
    sendButtonText: 'Pošlji',
    settingsHeaderText: 'Nastavitve',
    smsBadRequestError: 'Te številke ni bilo mogoče povezati. Poskusite znova ali uporabite drugo številko.',
    smsCancel: 'Prekliči',
    smsChangeNumber: 'Spremeni mojo številko',
    smsChannelDescription: 'Povežite svojo SMS-številko za nadaljevanje prek SMS-a.',
    smsChannelPendingDescription: 'Preverite svoja sporočila na številki {number} za potrditev telefonske številke.',
    smsContinue: 'Nadaljuj',
    smsInvalidNumberError: 'Vaša telefonska številka ni veljavna. Poskusite znova.',
    smsLinkCancelled: 'Povezava s {appUserNumber} je bila preklicana.',
    smsLinkPending: 'V teku',
    smsPingChannelError: 'Pri pošiljanju sporočila na vašo številko je prišlo do napake.',
    smsSendText: 'Pošlji mi sporočilo',
    smsStartTexting: 'Začni pogovor',
    smsTooManyRequestsError: 'Za to številko je bila nedavno zahtevana povezava. Poskusite znova čez {minutes} minut.',
    smsTooManyRequestsOneMinuteError: 'Za to številko je bila nedavno zahtevana povezava. Poskusite znova čez 1 minuto.',
    smsUnhandledError: 'Prišlo je do napake. Poskusite znova.',
    tapToRetry: 'Sporočilo ni bilo dostavljeno. Pritisnite enter za ponovni poskus.',
    tapToRetryForm: 'Obrazec ni bil poslan. Tapnite kjerkoli na obrazcu za ponovni poskus.',
    telegramChannelDescription: 'Povežite svoj Telegram račun za nadaljevanje prek Telegrama.',
    unsupportedMessageType: 'Nepodprta vrsta sporočila.',
    unsupportedActionType: 'Nepodprta vrsta dejanja.',
    linkError: 'Pri ustvarjanju povezave za ta kanal je prišlo do napake. Poskusite znova.',
    viberChannelDescription: 'Povežite svoj Viber račun za nadaljevanje prek Viberja.',
    viberChannelDescriptionMobile: 'Povežite svoj Viber račun, da boste obveščeni o odgovorih in nadaljevali pogovor prek Viberja. Za začetek namestite aplikacijo Viber in tapnite Poveži.',
    viberQRCodeError: 'Pri pridobivanju QR kode za Viber je prišlo do napake. Poskusite znova.',
    wechatChannelDescription: 'Povežite svoj WeChat račun, da boste obveščeni o odgovorih in nadaljevali pogovor prek WeChata. Za začetek skenirajte to QR kodo s pomočjo aplikacije WeChat.',
    wechatChannelDescriptionMobile: 'Povežite svoj WeChat račun, da boste obveščeni o odgovorih in nadaljevali pogovor prek WeChata. Za začetek shranite to QR kodo in jo naložite v <a href="weixin://dl/scan">skener QR kode</a>.',
    wechatQRCodeError: 'Pri pridobivanju QR kode za WeChat je prišlo do napake. Poskusite znova.',
    fileTooLargeError: 'Prekoračena največja dovoljena velikost datoteke ({size}).',
    shareLocation: 'Deli lokacijo',
    uploadDocument: 'Naloži dokument',
    uploadInvalidError: 'Neveljavna datoteka',
    fileTypeError: 'Nepodprta vrsta datoteke',
    formErrorInvalidEmail: 'E-poštni naslov ni veljaven',
    formErrorNoLongerThan: 'Vsebovati mora največ ({characters}) znakov',
    formErrorNoShorterThan: 'Vsebovati mora vsaj ({characters}) znakov',
    formErrorUnknown: 'To ni videti pravilno',
    formFieldSelectPlaceholderFallback: 'Izberite eno možnost...',
    uploadPhoto: 'Naloži fotografijo',
    uploadVirusError: 'V datoteki je bil zaznan virus in je bila zavrnjena',
    shoutoutText: 'Začni pogovor',
    cardClickText: 'Izbrano'
};
export { Slovenian };
